import type { PrescriptionSelectionWork } from '@/types/fetchPrescriptionSelection'
import { Fragment } from 'react'

export interface PrescriptionSelectionTagListProps {
	work: PrescriptionSelectionWork
	courseTitle: string
	hasShakespeareRule: boolean
	hasFormRequirement: boolean
}

const courseTitleStartsWith = (courseTitle: string, prefix: string): boolean =>
	courseTitle.toLowerCase().startsWith(prefix.toLowerCase())

const isStandard = (t: string) => courseTitleStartsWith(t, 'English Standard')
const isAdvanced = (t: string) => courseTitleStartsWith(t, 'English Advanced')
const isStudies = (t: string) => courseTitleStartsWith(t, 'English Studies')
const isEald = (t: string) => courseTitleStartsWith(t, 'English EAL/D')
const isExt1 = (t: string) => courseTitleStartsWith(t, 'English Extension 1')
const isExt2 = (t: string) => courseTitleStartsWith(t, 'English Extension 2')

function Tag({ label }: { label: string }) {
	return (
		<span className="inline-block px-2 py-1 mr-2 mb-1 text-sm font-bold rounded bg-nsw-off-white text-nsw-grey-01 border border-nsw-grey-04">
			{label}
		</span>
	)
}

export function PrescriptionSelectionTagList({
	work,
	courseTitle,
	hasShakespeareRule,
	hasFormRequirement,
}: PrescriptionSelectionTagListProps) {
	if (isExt2(courseTitle)) return null

	const showType =
		isStandard(courseTitle) ||
		isAdvanced(courseTitle) ||
		isStudies(courseTitle) ||
		isEald(courseTitle) ||
		isExt1(courseTitle)
	const showForm = hasFormRequirement && work['prescription-form'] !== null

	const showShakespeare = work.shakespeare === true && hasShakespeareRule

	if (!showType && !showForm && !showShakespeare) return null

	return (
		<Fragment>
			{showType && (
				<Tag label={work['prescription-type'].toLowerCase()} />
			)}
			{showForm && work['prescription-form'] !== null && (
				<Tag label={work['prescription-form'].toLowerCase()} />
			)}
			{showShakespeare && <Tag label="Shakespeare" />}
		</Fragment>
	)
}

export default PrescriptionSelectionTagList
